<template>
    <div id="navManage" class="background-ash pl20 pr20 pb20" v-loading="loading">
        <div class="search_list background-white">
		   <ul class="lists">
                <li>
                    <span>网站名称</span>
                    <el-input size="small" class="width180" @keyup.native.enter="page = 1, getList()" v-model="search.nameLike" placeholder="请输入网站名称"></el-input>
                </li>
                <li>
                    <span>导航分类</span>
                    <el-select size="small" class="select" v-model="search.navId" >
                        <el-option label="全部" value=""></el-option>
                        <el-option :label="item.name" :value="item.id" v-for="item in typeList" :key="item.id"></el-option>
                    </el-select>
                </li>
            </ul>
			<div class="btns" style="width:180px;">
                <el-button size="small" type="primary"  @click="page = 1, getList()">搜索</el-button>
                <el-button size="small" type="primary" plain @click="reset()">重置</el-button>
            </div>
	   </div>
       <!--内容-->
       <div class="pt20 content">
           <!--表头操作-->
           <div class="watchBar">
               <div class="btns right">
                   <el-button size="small" class="export-right" type="primary" @click="deleteT()">批量删除</el-button>
                   <el-button size="small" class="export-right" type="primary" @click="batchUpdateNav()">批量设置分类</el-button>
                   <el-button size="small" class="export-right" type="primary" @click="editWeb()">添加网站</el-button>
                </div>
           </div>
           <!--表格-->
           <div class="tab">
               <el-table ref="checkList" size="mini" :data="list" row-key="id" @selection-change="changeCheckId" tooltip-effect="dark" height="100%">
                   <el-table-column label="序号" type="selection" :reserve-selection="true"></el-table-column>
                    <el-table-column label="网站名称" prop="name"></el-table-column>
                    <el-table-column label="logo">
                        <template slot-scope="scope">
                            <div class="logo-img flex align-center">
                                <img v-if="scope.row.logoUrl" :src="$root.imgUrl+scope.row.logoUrl" />
                                <img v-else src="../../../assets/img/logo.png" />
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="描述" prop="remark"></el-table-column>
                    <el-table-column label="网址" >
                        <template slot-scope="scope">{{ scope.row.linkUrl || '无'}}</template>
                    </el-table-column>
                    <el-table-column label="排序值" prop="sort"></el-table-column>
                    <el-table-column label="所属分类" prop="navigationName"></el-table-column>
                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button type="text" @click="editWeb(scope.row)">编辑</el-button>
                            <el-button type="text" @click="deleteT(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
               </el-table>
           </div>
           <div class="page background-white text-right p20">
                <el-pagination class="pr20 pb20 background-white text-right pages" @size-change="pageSizeChange" @current-change="pageNoChange" :current-page="page" :page-sizes="[10, 20, 50, 100]"
        :page-size="size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
            <!-- 新增、编辑 -->
            <el-dialog title="添加/编辑网站" :visible.sync="isShow" width="580px" :close-on-click-modal="false" v-loading="loading2">
                <el-form :model="addParam" status-icon :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
                    <el-form-item label="网站名称" prop="name">
                        <el-input v-model.trim="addParam.name" size="small" class="width400" placeholder="请输入网站名称" maxlength="15"></el-input>
                    </el-form-item>
                    <el-form-item label="logo">
                        <el-upload class="avatar-uploader" :data="{type: 'CERTIFICATE'}" :headers="headers" action="https://kkbapi.yuncai998.com/admin/upload/picture" :show-file-list="false" :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="addParam.logoUrl" :src="$root.imgUrl+addParam.logoUrl" class="avatar">
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <span class="color-999">（建议图片尺寸34*34，大小5M以内，格式png/jpg）</span>
                    </el-form-item>
                    <el-form-item label="描述">
                        <el-input v-model.trim="addParam.remark" size="small" class="width400" placeholder="请输入描述" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="网址">
                        <el-input v-model.trim="addParam.linkUrl" size="small" class="width400" placeholder="请输入网址" maxlength="200"></el-input>
                    </el-form-item>
                    <el-form-item label="排序" prop="sort">
                        <el-input v-model.trim="addParam.sort" size="small" class="width400" placeholder="请输入排序值" maxlength="6"></el-input>
                    </el-form-item>
                    <el-form-item label="所属分类" class="last-form-item">
                        <el-select size="small" class="select width100" v-model="addParam.navId" >
                            <el-option :label="item.name" :value="item.id" v-for="item in typeList" :key="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button size="small"  @click="isShow = !isShow">&emsp;取消&emsp;</el-button>
                    <el-button type="primary" size="small" @click="save">&emsp;确定&emsp;</el-button>
                </span>
            </el-dialog>
            <!-- 批量修改 -->
            <el-dialog title="批量设置分类" :visible.sync="isShowUp" width="580px" :close-on-click-modal="false" v-loading="loading2">
                <div class="mb20 ml20">
                    已选中<span class="color-blue">{{checkId.length}}</span>个网站
                </div>
                <div class="mb20 ml20">
                    <span>所属分类</span>
                    <el-select size="small" class="select width100" v-model="navId" >
                        <el-option :label="item.name" :value="item.id" v-for="item in typeList" :key="item.id"></el-option>
                    </el-select>
                </div>
                <div class="btn-group ml20">
                    <span slot="footer" class="dialog-footer">
                        <el-button size="small"  @click="isShowUp = !isShowUp">&emsp;取消&emsp;</el-button>
                        <el-button type="primary" size="small" @click="confirmUpdate">&emsp;确定&emsp;</el-button>
                    </span>
                </div>
            </el-dialog>
       </div>
    </div>
</template>
<script>
export default {
    name: 'navManage', //导航管理
    data () {
        var checkSort = (rule, value, callback) => {
			var reg = /^(?:0|[1-9][0-9]*)$/; //验证只能输入数字
			if(!reg.test(value)){
				callback(new Error('只能输入数字'));
            }else {
				callback();
			}
		};
        return {
            loading: false,
            loading2: false,
            search_upback: {
                nameLike: '', // 网站名称
                navId: '', // 导航分类
            },
            typeList: [], //导航分类
            search: {},
            page: 1,
            size: 10,
            list: [],
            total: 0,
            checkId: [], //选中的网站
            isShow: false,
            addParam: {
                name: '',
                logoUrl: '',
                remark: '',
                linkUrl: '',
                sort: '',
                navId: '',
                id: null
            },
            rules: {
                name:[{required:true,message:'请输入网站名称',trigger:'blur'}],
                sort:[{validator: checkSort, trigger: 'blur'}]
            },
            headers: {
                'App-Id': '6A0A26F3DDD',
                'Request-Timestamp': '',
                'Request-Signature': '',
                'Request-Token': sessionStorage.getItem('token')
            }, //上传图片需要的请求头
            isShowUp: false, //批量修改网站弹窗
            navId: null, //批量修改的导航
        }
    },
    watch: {
        isShow (val) {
            if (!val) {
                this.addParam.name = ''
                this.addParam.logoUrl = ''
                this.addParam.remark = ''
                this.addParam.linkUrl = ''
                this.addParam.sort = ''
                this.addParam.navId = ''
                this.addParam.id = ''
                this.$refs.form.clearValidate()
            }
        }
    },
    methods: {
        // 重置搜索条件
        reset() {
            this.search = JSON.parse(JSON.stringify(this.search_back))
            this.page = 1
            this.getList()
        },
        handleAvatarSuccess(res, file) {
            this.addParam.logoUrl = res.data.relative
        },
        setHeader (config) {
            let textSign = config.url;
            //排列参数data
            if (config.data != undefined) {
                textSign += JSON.stringify(config.data)
            }
            //拼接时间蹉
            let time = this.moment(new Date()).valueOf()
            // textSign += time
            //拼接appSecret
            textSign += '60D06AFD5EB025EE98A3C10872AF9DBB'
            let sign = this.md5(textSign).toUpperCase() //md5加密并转成大写
            //设置最终请求地址
            this.headers['Request-Timestamp'] = time;
            this.headers['Request-Signature'] = sign;
        },
        beforeAvatarUpload(file) {
            const isJPG = (file.type === 'image/jpeg' || file.type === 'image/png');
            const isLt2M = file.size / 1024 / 1024 < 5;

            if (!isJPG) {
            this.$message.error('上传logo图片只能是 JPG 格式!');
            }
            if (!isLt2M) {
            this.$message.error('上传logo图片大小不能超过 5MB!');
            }
            let formData = new FormData()
            formData.append('file', file)
            formData.append('type','CERTIFICATE')
            this.setHeader({
                url: '/admin/upload/picture',
                data: formData
            })
            return isJPG && isLt2M;
        },
        //添加编辑网站
        editWeb (val) {
            if (!!val) {
                this.addParam.name = val.name
                this.addParam.logoUrl = val.logoUrl
                this.addParam.remark = val.remark
                this.addParam.linkUrl = val.linkUrl
                this.addParam.sort = val.sort
                this.addParam.navId = val.navigationId
                this.addParam.id = val.id
            }
            this.isShow = true
        },
        //列表勾选改变
        changeCheckId (val) {
            this.checkId = val
        },
        //获取所有导航分类
        getTypeList () {
            this.$http('POST', '/admin/nav/list', {}, {}, (status, res) => {
                if (status) {
                    if(!!res.data && res.data.length > 0) {
                       this.typeList = res.data;
                   }else {
                       this.typeList = [];
                   }
                   if (this.$route.query.navId) {
                        this.search_upback.navId = +this.$route.query.navId
                    }
                    this.search = {...this.search_upback}
                    this.getList(); //获取所有网站
                }
            })
        },
        //保存分类
        save () {
            this.$refs.form.validate( (validator) => {
                if (validator) {
                    this.loading2 = true
                    this.$http('POST', '/admin/website/save', {}, this.addParam, (status, res) => {
                        this.loading2 = false
                        if (status) {
                            this.success( res.message);
                            this.isShow = false;
                            this.getList();
                        }
                    })
                }
            })
        },
        //删除分类
        deleteT (id) {
            let ids = []
            if (id) {
                ids = [id]
            } else {
                if (this.checkId.length <= 0){
                    this.error('请选择要删除的网站!')
                    return false
                } else {
                    ids = this.checkId.map((item)=>(item.id))
                }
            }
            this.confirm('<div>是否删除选中的网站信息？</div>',(index)=>{
                layer.close(index)
                this.loading = true
                this.$http('POST', '/admin/website/batchDelete', {}, {ids: ids}, (status, res) => {
                    this.loading = false
                    if (status) {
                        this.$refs.checkList.clearSelection()
                        this.success('删除成功！');
                        this.getList ()
                    }
                })
            })
        },
        //批量修改导航
        batchUpdateNav () {
            this.navId = null
            if (this.checkId.length <= 0) {
                this.error('请选择要修改的网站')
            } else {
                this.isShowUp = true
            }
        },
        confirmUpdate () {
            if (!this.navId ) {
                this.error('请选择导航')
            } else {
                this.loading2 = true
                const ids = this.checkId.map((item)=>(item.id))
                this.$http('POST', '/admin/website/batchUpdateNav', {}, {navId: this.navId, ids: ids}, (status, res) => {
                    this.loading2 = false
                    if (status) {
                        this.success( res.message);
                        this.isShowUp = false;
                        this.$refs.checkList.clearSelection()
                        this.getList();
                    }
                })
            }
        },
        pageSizeChange(val) {
            this.size = val
            this.page = 1
            this.getList()
        },
        pageNoChange(val) {
            this.page = val
            this.getList()
        },
        reset() {
            this.search = JSON.parse(JSON.stringify(this.search_upback))
            this.page = 1
            this.getList()
        },
        getList () {
            let param = {...this.search};
            param.page = (this.page - 1);
            param.size = this.size
            this.loading = true
            this.$http('POST', '/admin/website/page', {}, param, (status, res) => {
                this.loading = false
                if (status) {
                   if(!!res.content && res.content.length > 0) {
                       this.list = res.content;
                   }else {
                       this.list = [];
                   }
                   this.total = res.totalCount;
                }
            })
        },
    },
    mounted() {
        this.getTypeList(); //获取所有导航
    },
}
</script>
<style scoped>
#navManage {width: 100%;height: calc(100vh - 132px);}
#navManage .content {height: calc(100% - 76px);}
#navManage .content .tab {height: calc(100% - 125px);}
#navManage >>>.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
#navManage >>>.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
#navManage >>>.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
#navManage >>>.avatar {
    width: 100px;
    height: 100px;
    display: block
}
.logo-img{width: 60px; height: 60px; vertical-align: middle;}
.logo-img img{max-width: 100%; max-height: 100%; object-fit: contain;}
</style>


// WEBPACK FOOTER //
// src/views/pcNavigation/pcNavigation2/navManage.vue